import { getCurrentScope, onScopeDispose, readonly, ref, type Ref } from 'vue'

const QUERY = '(prefers-reduced-motion: reduce)'

/** Tracks the reduced-motion preference, updating when the founder changes it. */
export function useReducedMotion(): Readonly<Ref<boolean>> {
  const media = typeof matchMedia === 'function' ? matchMedia(QUERY) : null
  const reduced = ref(media?.matches ?? false)
  if (media === null) return readonly(reduced)

  const update = (event: MediaQueryListEvent): void => {
    reduced.value = event.matches
  }
  media.addEventListener('change', update)
  if (getCurrentScope()) onScopeDispose(() => media.removeEventListener('change', update))
  return readonly(reduced)
}
